
const About = () => {
    return (
        <div className="about">
            <h1 className="pageTitle">About Me</h1>
            <p>
                Hello there! I'm Topher Hook, a passionate and results-driven software engineer with a keen focus on creative problem-solving.<br/>
                <br/>
                With a foundation in software development, I thrive on tackling challenges head-on and finding innovative solutions.<br/>
                <br/>
                My commitment to continuous learning ensures that I stay on the cutting edge of technology, always seeking new ways to <br/>enhance efficiency and user experiences.<br/>
                <br/>
                As you explore my portfolio, you'll discover a collection of projects that showcase my dedication to clean, elegant code <br/>and my ability to turn complex problems into streamlined solutions.<br/> 
                <br/>
                I'm excited about the possibilities that technology offers and am always eager to take on new challenges.<br/>
                <br/>
                Let's connect and explore how we can create something exceptional together!
            </p>
        </div>
    )
}

export default About
